import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Button from 'components/ui/Button';
import Icon from 'components/AppIcon';

const NotFound = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    // Auto-redirect after 3 seconds
    const timer = setTimeout(() => {
      if (isAuthenticated) {
        navigate('/login', { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [isAuthenticated, navigate]);

  const handleGoHome = () => {
    if (isAuthenticated) {
      navigate('/login', { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-6">
          <div className="relative">
            <h1 className="text-9xl font-bold text-primary opacity-20">404</h1>
          </div>
        </div>

        <h2 className="text-2xl font-medium text-onBackground mb-2">Page introuvable</h2>
        <p className="text-onBackground/70 mb-8">
          La page que vous recherchez n'existe pas. Redirection automatique dans 3 secondes...
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            variant="primary"
            icon={<Icon name="ArrowLeft" />}
            iconPosition="left"
            onClick={() => window.history?.back()}
          >
            Retour
          </Button>

          <Button
            variant="outline"
            icon={<Icon name="Home" />}
            iconPosition="left"
            onClick={handleGoHome}
          >
            {isAuthenticated ? 'Connexion' : 'Accueil'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
